import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    article : {

    }
  },
  getters: {
    doneTodos: state => {
    //  return state.todos.filter(todo => todo.done);
    }
  },
  mutations: {

  },
  actions: {

  }
})
